module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: _vm.containerStyle
  }, _vm._l((_vm.data), function(item, i) {
    return _c('div', {
      key: 'skid-' + i,
      ref: "skid",
      refInFor: true,
      staticClass: ["dof-skid"],
      style: {
        width: 750 + item.right.length * 160 + 'px',
        height: _vm.height + 'px'
      },
      on: {
        "click": function($event) {
          _vm.onNodeClick(item, i)
        },
        "touchstart": function (e) { return !_vm.isAndroid && _vm.onPanStart(e, item, i); },
        "horizontalpan": function (e) { return _vm.isAndroid && _vm.onPanStart(e, item, i); },
        "touchend": function (e) { return _vm.onPanEnd(e, item, i); }
      }
    }, [_c('div', {
      staticClass: ["swipe-action-center"],
      style: _vm.styles
    }, [_vm._t("default", null, {
      val: {
        item: item,
        index: i
      }
    })], 2), _c('div', {
      staticClass: ["swipe-action-right"]
    }, _vm._l((item.right), function(child, childIdx) {
      return _c('div', {
        key: 'child-' + childIdx,
        ref: "button_small",
        refInFor: true,
        staticClass: ["swipe-action-child"],
        on: {
          "click": function($event) {
            _vm.onRightNode(item, child, i)
          }
        }
      }, [(child.text.length <= 3) ? _c('text', {
        staticClass: ["swipe-action-text"],
        style: Object.assign({
          lineHeight: _vm.height + 'px'
        }, child.style || {})
      }, [_vm._v(_vm._s(child.text))]) : _vm._e(), (child.text.length >= 4) ? _c('div', {
        staticClass: ["swipe-action-child"],
        style: Object.assign({
          height: _vm.height + 'px'
        }, child.style || {})
      }, [_c('text', {
        staticClass: ["swipe-action-text"],
        style: Object.assign({
            marginTop: _vm.heightChoice + 'px'
          },
          child.style || {}
        )
      }, [_vm._v(_vm._s(child.text.slice(0, child.text.length / 2)))]), _c('text', {
        staticClass: ["swipe-action-text"],
        style: Object.assign({
            marginBottom: _vm.heightChoice + 'px'
          },
          child.style || {}
        )
      }, [_vm._v(_vm._s(child.text.slice(2, child.text.length)))])]) : _vm._e()])
    }))])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-dd65dfac!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-swipe-list/index.vue
// module id = 670
// module chunks = 0 1